import { UserRole } from '../../../../interfaces/common/roles';
import { BranchType } from '../../../../interfaces/delivery-company/branches';
import { EmployeeType } from './create-employee-form.interfaces';

export type EmployeeInput = Omit<EmployeeType, 'branch' | 'account'> & {
  account: { roles: number[]},
}
export const emptyEmployee: EmployeeInput = {
  id: '',
  name: '',
  phone_number: '',
  branches: [],
  password: '',
  roles: [],
  is_admin: false,
  account: {roles: []}
};
